import React from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import { motion } from 'framer-motion';
import Home from './components/Home';
import CategoryView from './components/CategoryView';
import PoseDetail from './components/PoseDetail';
import SelectionView from './components/SelectionView';
import Footer from './components/Footer';
import './App.css';

function App() {
  return (
    <Router>
      <div className="min-h-screen" style={{backgroundColor: '#FBF8FB'}}>
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.6 }}
          className="container mx-auto px-4 py-6"
        >
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/category/:categoryId" element={<CategoryView />} />
            <Route path="/pose/:poseId" element={<PoseDetail />} />
            <Route path="/selection" element={<SelectionView />} />
          </Routes>
        </motion.div>
        <Footer />
      </div>
    </Router>
  );
}

export default App;